import IUser from "@/types/Models/Account/IUser";
import IUserBase from "@/types/Models/Account/IUserBase";

/**
 * User Klasse, wird für erweiterte Funktionalitäten benötigt
 */
export default class User implements IUser {
	id: string;
	email: string;
	firstname: string;
	lastname: string;
	identityRoles?: string[];

	constructor(user: IUser | IUserBase) {
		this.id = user.id;
		this.email = user.email;
		this.firstname = user.firstname;
		this.lastname = user.lastname;
		if ("identityRoles" in user && user.identityRoles) {
			this.identityRoles = user.identityRoles;
		}
	}

	public getFullName(): string {
		return this.firstname + " " + this.lastname;
	}

	public getEmail(): string {
		return this.email;
	}
}
